import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

/**
 * Shared Submit / Cancel / Delete action triad used by the filing-form
 * sheets (role0 — filing prerequisites, role1 — filing info). The
 * arrangement (horizontal gap, alignment) is owned by this component so
 * every consumer renders identically; previously role0 had the styling
 * inline and role1 was missing it, producing inconsistent spacing.
 *
 * Inputs are pre-computed booleans rather than the raw FormGroup so the
 * abstraction does not leak form state across the boundary (DIP).
 *
 * Exposes a default content slot after the Delete button for controls that
 * belong in this row without being part of the triad — see the comment in the
 * template. A host that projects nothing renders exactly as before.
 */
@Component({
  selector: 'app-filing-action-buttons',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './filing-action-buttons.component.html',
  styleUrls: ['./filing-action-buttons.component.css'],
})
export class FilingActionButtonsComponent {
  @Input() submitDisabled = false;
  @Input() cancelDisabled = false;
  /** When true the Submit button shows a spinner and is non-clickable (an
   * in-flight phase-two submit). Owned by the host sheet (role0/role1). */
  @Input() isSubmitting = false;

  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
}
